/** 在 src/config/ 内编辑 重新运行后可使用 */ 

export const NODE_ENV =  'production'; // 打包环境
export const API_PATH = 'https://api-m3cdk.17m3.com'; // 接口请求地址